import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import Avatar from 'components/Avatar';
import Dropdown from 'components/Dropdown';
import AsyncSelect from 'components/AsyncSelect';
import BookingStatus from 'components/BookingStatus';
import IconButton from 'components/IconButton';

import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import {buildBookingOptions} from 'components/Fields/BookingSelectField';
import {BookingOption} from 'components/Fields/BookingSelectField/components';

import {formatDate} from 'utils/datetime';

import rightStrike from './assets/tail-right.svg';
import searchIcon from 'assets/icons/search.svg';

import './styles.css';

const BookingSelectedValue = ({
  object: {primaryTenant, secondaryTenant, period, status}
}) => {
  const {
    avatarCropped,
    internalAvatarCropped,
    fullName,
    initials
  } = primaryTenant;

  return (
    <div className="BookingSelectedValue colab-row-space-between">
      <div className="BookingSelectedValue__allTenants colab-centered-v">
        <div className="BookingSelectedValue__allTenants__avatars colab-centered-v">
          <Avatar
            className="avatar"
            url={internalAvatarCropped || avatarCropped}
            initials={initials}
          />
          {secondaryTenant && (
            <Avatar
              className="avatar"
              url={
                secondaryTenant.internalAvatarCropped ||
                secondaryTenant.avatarCropped
              }
              initials={secondaryTenant.initials}
            />
          )}
        </div>
        <div
          className={classNames('info colab-bold colab-centered-v', {
            hasAllTenants: secondaryTenant
          })}>
          <div>{fullName}</div>
          {secondaryTenant && <div>{secondaryTenant.fullName}</div>}
        </div>
      </div>

      <div className="colab-centered-v">
        <div className="colab-bold">{formatDate(period.startDate)}</div>
        <img
          className="colab-sidepadding-1"
          src={rightStrike}
          alt="Right strike"
        />
        <div className="colab-bold">{formatDate(period.endDate)}</div>
      </div>
      <div className="colab-centered-v">
        <BookingStatus status={status} />
      </div>
    </div>
  );
};

interface BookingFilterProps {
  fetchSdk: any;
  onChange: any;
  value: any;
  bookingSelectRef?: any;
}

class BookingFilter extends React.Component<BookingFilterProps> {
  state = {
    position: {left: 0, top: 0},
    sectionOpened: false,
    isOpen: false
  };

  onValueFocus = event => {
    const position = event.target.getBoundingClientRect();

    this.setState({
      position: {left: position.left - 350, top: position.top + 30},
      isOpen: true
    });
  };

  toggleSection = () => {
    this.setState({sectionOpened: !this.state.sectionOpened});
  };

  closePopup = () => {
    this.setState({isOpen: false});
  };

  getMenuRenderer = props => {
    const {position, isOpen} = this.state;

    return (
      <Dropdown
        isOpen={isOpen}
        position={position}
        onClose={this.closePopup}
        appendToBody={true}
        className="bookingOptionsDropdown">
        <div className="bookingOptionsMenuRenderer">
          {props.options.map(option => (
            <div
              key={option.value}
              onClick={() => props.selectValue(option)}
              onMouseOver={() => props.focusOption(option)}
              className={`optionWrapper Select-option colab-centered-v ${
                props.focusedOption &&
                props.focusedOption.value === option.value
                  ? 'is-focused'
                  : ''
              }`}
              role="option">
              <BookingOption {...option} />
            </div>
          ))}
        </div>
      </Dropdown>
    );
  };

  clearBookingOption = () => {
    this.props.onChange('booking', null);
  };

  render() {
    const {fetchSdk, onChange, value} = this.props;

    return (
      <div
        className={classNames('FilterSection BookingFilter', {
          'FilterSection--opened': this.state.sectionOpened
        })}>
        <div className="FilterSection__header colab-centered-v colab-bold">
          <IconButton
            src={arrowRightIcon}
            srcActive={arrowDownIcon}
            alt="Toggle section"
            onClick={this.toggleSection}
            active={this.state.sectionOpened}
          />
          <div>Booking</div>
        </div>
        <div className="FilterSection__content">
          <div
            className={classNames('inputWrapper', {
              hasValue: value
            })}
            style={{backgroundImage: !value ? `url(${searchIcon})` : 'none'}}>
            <AsyncSelect
              ref={this.props.bookingSelectRef}
              fetchFunction={fetchSdk}
              buildOptions={buildBookingOptions}
              onClear={this.clearBookingOption}
              valueRenderer={BookingSelectedValue}
              arrowRenderer={null}
              creatable={false}
              filterOptions={false}
              placeholder={'Search by name or email'}
              onChange={bookingOption =>
                onChange('booking', _.get(bookingOption, 'value'))
              }
              onFocus={this.onValueFocus}
              menuRenderer={props => this.getMenuRenderer(props)}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default BookingFilter;
